import type { QueryHookOptions } from "@apollo/client";
/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
import { gql, useQuery } from "@apollo/client";

import type { WordpressSearchLandingPageResultsType } from "@emerson/types/WordpressSearchLandingPageResultsType";

const WordpressSearchLandingPage_Emerson_Query = gql`
  query WordpressSearchLandingPage_Emerson_Query(
    $attribute: String
    $category: String
    $condition: String
    $brand: String
  ) {
    searchLandingPages(
      where: { attribute: $attribute, category: $category, condition: $condition, brand: $brand }
    ) {
      nodes {
        title
        searchLandingActionUrl
        searchLandingFsActionUrl
        searchLandingImageDesktop
        searchLandingImageMobile
      }
    }
  }
`;

interface Variables {
  attribute?: string;
  category?: string;
  condition?: string;
  brand?: string;
}

const useWordpressSearchLandingPageQuery = (
  options?: QueryHookOptions<WordpressSearchLandingPageResultsType, Variables>
) =>
  useQuery<WordpressSearchLandingPageResultsType>(WordpressSearchLandingPage_Emerson_Query, {
    context: { clientName: "wordpress" },
    ...options,
  });

export { useWordpressSearchLandingPageQuery, WordpressSearchLandingPage_Emerson_Query };
